import { render, staticRenderFns } from "./importLog.vue?vue&type=template&id=04877e7f&scoped=true"
import script from "./importLog.vue?vue&type=script&lang=ts"
export * from "./importLog.vue?vue&type=script&lang=ts"
import style0 from "./importLog.vue?vue&type=style&index=0&id=04877e7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04877e7f",
  null
  
)

export default component.exports